import type { LabeledValue } from "@/components/atomic-crm/types";

export type CatalogCurrency = "COP" | "USD";
export type BillingType = "one_time" | "monthly" | "mixed";

export interface CatalogProduct {
  value: string;
  label: string;
  family: string;
  currency: CatalogCurrency;
  listAmount: number;
  monthlyAmount: number;
  billingType: BillingType;
  deliveryBusinessDays: number | null;
}

/** ARKA list prices. Update this file when a public price or SKU changes (maintenance). */
export const ARKA_CATALOG_PRODUCTS: CatalogProduct[] = [
  {
    value: "diagnostico",
    label: "Diagnóstico",
    family: "diagnostico",
    currency: "COP",
    listAmount: 0,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: null,
  },
  {
    value: "web_landing",
    label: "Landing Page",
    family: "web",
    currency: "COP",
    listAmount: 790_000,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: 8,
  },
  {
    value: "web_multisection",
    label: "Web Multisección",
    family: "web",
    currency: "COP",
    listAmount: 1_290_000,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: 8,
  },
  {
    value: "web_catalog",
    label: "Web con Catálogo",
    family: "web",
    currency: "COP",
    listAmount: 2_600_000,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: 15,
  },
  {
    value: "web_system",
    label: "Sistema Web ARKA",
    family: "web",
    currency: "COP",
    listAmount: 2_790_000,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: 20,
  },
  {
    value: "web_app",
    label: "App Web ARKA",
    family: "web",
    currency: "COP",
    listAmount: 3_490_000,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: 25,
  },
  {
    value: "chasqui_assist",
    label: "Chasqui Assist",
    family: "chasqui",
    currency: "COP",
    listAmount: 490_000,
    monthlyAmount: 139_000,
    billingType: "mixed",
    deliveryBusinessDays: 10,
  },
  {
    value: "chasqui_booking",
    label: "Chasqui Booking",
    family: "chasqui",
    currency: "COP",
    listAmount: 890_000,
    monthlyAmount: 199_000,
    billingType: "mixed",
    deliveryBusinessDays: 15,
  },
  {
    value: "chasqui_commerce",
    label: "Chasqui Commerce",
    family: "chasqui",
    currency: "COP",
    listAmount: 1_190_000,
    monthlyAmount: 279_000,
    billingType: "mixed",
    deliveryBusinessDays: 20,
  },
  {
    value: "booking_full",
    label: "Booking completo",
    family: "booking",
    currency: "COP",
    listAmount: 790_000,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: 12,
  },
  {
    value: "booking_module",
    label: "Solo módulo de agendamiento",
    family: "booking",
    currency: "COP",
    listAmount: 490_000,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: 10,
  },
  {
    value: "prospector_maps",
    label: "Prospector Maps",
    family: "prospector",
    currency: "USD",
    listAmount: 0,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: null,
  },
  {
    value: "prospector_linkedin",
    label: "Prospector LinkedIn",
    family: "prospector",
    currency: "USD",
    listAmount: 0,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: null,
  },
  {
    value: "automation_simple",
    label: "Automatización simple",
    family: "prospector",
    currency: "COP",
    listAmount: 290_000,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: 10,
  },
  {
    value: "automation_medium",
    label: "Automatización media",
    family: "prospector",
    currency: "COP",
    listAmount: 590_000,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: 15,
  },
  {
    value: "automation_advanced",
    label: "Automatización avanzada",
    family: "prospector",
    currency: "COP",
    listAmount: 0,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: null,
  },
  {
    value: "integration_simple",
    label: "Integración simple",
    family: "integraciones",
    currency: "COP",
    listAmount: 0,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: 8,
  },
  {
    value: "integration_multi",
    label: "Integraciones múltiples",
    family: "integraciones",
    currency: "COP",
    listAmount: 150_000,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: 12,
  },
  {
    value: "integration_api",
    label: "API personalizada",
    family: "integraciones",
    currency: "COP",
    listAmount: 0,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: null,
  },
  {
    value: "identidad",
    label: "Identidad de marca",
    family: "identidad",
    currency: "COP",
    listAmount: 260_000,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: 8,
  },
  {
    value: "crm_starter_self",
    label: "CRM Cloud Starter (self-serve)",
    family: "crm",
    currency: "COP",
    listAmount: 0,
    monthlyAmount: 79_000,
    billingType: "monthly",
    deliveryBusinessDays: 2,
  },
  {
    value: "crm_starter_assisted",
    label: "CRM Cloud Starter (ARKA lo configura)",
    family: "crm",
    currency: "COP",
    listAmount: 490_000,
    monthlyAmount: 79_000,
    billingType: "mixed",
    deliveryBusinessDays: 12,
  },
  {
    value: "crm_business",
    label: "CRM Cloud Business",
    family: "crm",
    currency: "COP",
    listAmount: 0,
    monthlyAmount: 129_000,
    billingType: "monthly",
    deliveryBusinessDays: null,
  },
  {
    value: "crm_business_assisted",
    label: "CRM Cloud Business (ARKA lo configura)",
    family: "crm",
    currency: "COP",
    listAmount: 490_000,
    monthlyAmount: 129_000,
    billingType: "mixed",
    deliveryBusinessDays: 20,
  },
  {
    value: "crm_custom",
    label: "CRM a la medida",
    family: "crm",
    currency: "COP",
    listAmount: 1_800_000,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: 30,
  },
  {
    value: "other_custom",
    label: "Otro (describir)",
    family: "other",
    currency: "COP",
    listAmount: 0,
    monthlyAmount: 0,
    billingType: "one_time",
    deliveryBusinessDays: null,
  },
];

export const DEAL_CURRENCIES: LabeledValue[] = [
  { value: "COP", label: "COP — peso colombiano" },
  { value: "USD", label: "USD — dólar" },
];

export const BILLING_TYPES: LabeledValue[] = [
  { value: "one_time", label: "Pago único" },
  { value: "monthly", label: "Mensualidad" },
  { value: "mixed", label: "Setup + mensualidad" },
];

export function findCatalogProduct(
  value: string | null | undefined,
): CatalogProduct | undefined {
  if (!value) {
    return undefined;
  }
  return ARKA_CATALOG_PRODUCTS.find((product) => product.value === value);
}

export function getProductsForFamily(family: string | null | undefined): CatalogProduct[] {
  if (!family) {
    return [];
  }
  return ARKA_CATALOG_PRODUCTS.filter((product) => product.family === family);
}

export function getProductLabel(value: string | null | undefined): string {
  return findCatalogProduct(value)?.label ?? value ?? "";
}

export function dealHasMonthly(billingType: string | null | undefined): boolean {
  return billingType === "monthly" || billingType === "mixed";
}
